import React, { Component } from "react";
import PropTypes from "prop-types";
export class Talks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      talksCount: 0
    };
    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  handlePrevious() {
    const currentIndex = this.state.index;
    this.setState(() => ({
      index: currentIndex - 1
    }));
  }

  handleNext() {
    const currentIndex = this.state.index;
    this.setState(() => ({
      index: currentIndex + 1
    }));
  }

  componentDidMount() {
    let talks = [];
    this.props.sessions.forEach(session => {
      const sessionTalks = session.talks;
      talks = [...talks, ...sessionTalks];
    });
    this.setState(() => ({
      talksCount: talks.length,
      talks: talks
    }));
  }

  render() {
    if (!this.state.talks || this.state.talksCount <= 0) return /*#__PURE__*/React.createElement("br", null);
    const {
      index,
      talksCount
    } = this.state;
    const talk = this.state.talks[index];
    const talkId = index + 1;
    const startTime = new Date(talk.startTime);
    const endTime = new Date(talk.endTime);

    const getLocalTime = date => date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true
    });

    const renderTalkInfo = talk => /*#__PURE__*/React.createElement("div", {
      className: "talkInfo"
    }, /*#__PURE__*/React.createElement("div", {
      className: "talk-title"
    }, talk.title), /*#__PURE__*/React.createElement("div", {
      className: "timeSlot"
    }, getLocalTime(startTime), " - ", getLocalTime(endTime)), /*#__PURE__*/React.createElement("div", {
      className: "description"
    }, talk.description));

    const renderSpeakerInfo = speakers => {
      const renderSpeaker = speaker => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        className: "pic",
        src: speaker.profilePicture,
        alt: speaker.name,
        loading: "lazy"
      }), /*#__PURE__*/React.createElement("div", {
        className: "info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "name"
      }, speaker.name), /*#__PURE__*/React.createElement("div", {
        className: "desgination"
      }, speaker.desgination)));

      if (speakers && speakers.length == 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: "speakerInfo"
        }, renderSpeaker(speakers[0]));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "speakers"
      }, speakers && speakers.map((speaker, index) => /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "speaker"
      }, renderSpeaker(speaker))));
    };

    return /*#__PURE__*/React.createElement("div", {
      className: "talks"
    }, /*#__PURE__*/React.createElement("div", {
      id: "talk-".concat(index),
      className: "talk"
    }, renderTalkInfo(talk), renderSpeakerInfo(talk.speakers), talksCount > 1 && /*#__PURE__*/React.createElement("div", {
      className: "actions"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: "bold"
    }, String(talkId).padStart(2, "0"), " "), /*#__PURE__*/React.createElement("span", {
      className: "light"
    }, "/ ", String(talksCount).padStart(2, "0"))), /*#__PURE__*/React.createElement("button", {
      id: "prev",
      alt: "Previous talk",
      disabled: index == 0,
      onClick: this.handlePrevious
    }), /*#__PURE__*/React.createElement("button", {
      id: "next",
      alt: "Next talk",
      disabled: index == talksCount - 1,
      onClick: this.handleNext
    }))));
  }

}
Talks.propTypes = {
  sessions: PropTypes.array.isRequired
};